<template>
    <div>
        <AppNavBar :site-sections="siteSections"
                   :user-tools="userTools"
                   :near-me="nearMe"
                   :current-site-section="currentSiteSection"
                   :user-location="includeLocation ? getCurrentAddressAsString(this, false) : null"
                   :include-location="includeLocation"
                   :logo-link="`/${currentSiteSection}`"
                   :phone-number="phoneNumber"
                   :is-carrier-page="isCarrierPage"
                   :carrier-page-number="carrierPageNumber"
                   :target="target"
                   @change-location="changeLocation()"
                   @overlay-opened="overlayOpened()"
                   @overlay-closed="overlayClosed()" />
        <AppNavMenu :menu="menu"
                    :can-show="canShow"
                    :site-sections="siteSections"
                    :current-site-section="currentSiteSection"
                    :logo-link="`/${currentSiteSection}`"
                    :ctas="ctas"
                    :phone-number="phoneNumber"
                    :include-search="includeSearch"
                    :target="target"
                    @show-search="showSearch()"
                    @get-started="getStarted()"
                    @overlay-opened="overlayOpened()"
                    @overlay-closed="overlayClosed()" />
        <AppNavMenuMobile :include-search="includeSearch"
                          :can-show="canShow"
                          :logo-link="`/${currentSiteSection}`"
                          :site-sections="siteSections"
                          :current-site-section="currentSiteSection"
                          :is-carrier-page="isCarrierPage"
                          :carrier-page-number="carrierPageNumber"
                          :menu="menu"
                          :user-tools="userTools"
                          :near-me="nearMe"
                          :phone-number="phoneNumber"
                          :legal-links="legalLinks"
                          :target="target"
                          @change-location="changeLocation()"
                          @overlay-opened="overlayOpened()"
                          @overlay-closed="overlayClosed()" />
    </div>
</template>

<script>
  import {mapGetters, mapActions, mapState} from 'vuex'
  import AppNavBar from './appNavBar.vue'
  import AppNavMenu from './appNavMenu.vue'
  import AppNavMenuMobile from './appNavMenuMobile.vue'
  export default {
        name: 'AppNav',
        components: {
            AppNavBar,
            AppNavMenu,
            AppNavMenuMobile,
        },
        props: {
            menu: {
                type: Array,
                default: () => [],
            },
            siteSections: {
                type: Array,
                default: () => [],
            },
            userTools: {
                type: Array,
                default: () => [],
            },
            nearMe: {
                type: Array,
                default: () => [],
            },
            legalLinks: {
                type: Array,
                default: () => [],
            },
            currentSiteSection: {
                type: String,
                default: 'residential',
            },
            ctas: {
                type: Array,
                default: () => [],
            },
            addressInToggle: {
                type: String,
                default: ""
            },

            /* the rest here are for the My World nav */
            includeLocation: {
                type: Boolean,
                default: () => true,
            },
            includeSearch: {
                type: Boolean,
                default: () => true,
            },
            target: {
                type: [null, String],
                default: null,
                validator: val => [
                    '_parent',
                    '_top',
                    '_blank',
                    '_self',
                ].includes(val),
            },
            heading: {
                type: String,
                default: null,
            },
            subheading: {
                type: String,
                default: null,
            },
        },
        data: () => ({
            isCarrierPage: false,
            carrierPageNumber: '844-205-5497'
        }),
        computed: {
            ...mapGetters([
                'getCurrentAddressAsString',
            ]),
            ...mapState([
                'meta',
            ]),
            phoneNumber(){
                return {
                    'residential': this.resiPhone,
                    'business': this.bizPhone,
                    'communities': '855-223-6138',
                }[this.currentSiteSection] || '855-706-7455'
            },
            resiPhone() {
                return this.meta.marketType === 'fiber-competitive' ? '855-284-3807'
                    : this.meta.marketType === 'ohio' ? '844-489-7506'
                    : '855-706-7455'
            },
            bizPhone() {
                return this.meta.marketType === 'fiber-competitive' ? '855-210-5503'
                    : this.meta.marketType === 'ohio' ? '855-617-7998'
                    : '888-684-6595'
            }
        },
        watch: {},
        created () {},
        mounted () {
            if (window.location.href.indexOf("carrier-service") > -1) {
                this.isCarrierPage = true;
            }
        },
        updated () {},
        destroyed () {},
        methods: {
            ...mapActions([
                'adjustOpenOverlaysCounter',
                'toggleCheckAvailabilityModal'
            ]),
            canShow(audience) {
                if (audience) {
                    const zipcodes   = audience.zipcodes? audience.zipcodes.replace(/\s/g,'').split(','): null
                    const marketType = audience.marketType? audience.marketType.replace(/\s/g,'').split(','): null
                    let whitelisted, blacklisted

                    if (zipcodes && this.meta.postalCode){
                        whitelisted = zipcodes.filter(z => !z.includes('!'))|| []
                        blacklisted = zipcodes.filter(z => z.includes('!'))|| []

                        return (
                            (
                                !whitelisted.length ||
                                whitelisted.findIndex(z => z === this.meta.postalCode.substring(0, 5)) >= 0
                            ) && (
                                !blacklisted.length ||
                                !(blacklisted.findIndex(z => z.replace('!', '') === this.meta.postalCode.substring(0, 5)) >= 0)
                            )
                        )

                    } else if (marketType) {
                        whitelisted = marketType.filter(m => !m.includes('!'))|| []
                        blacklisted = marketType.filter(m => m.includes('!'))|| []

                        return (
                            (
                                !whitelisted.length ||
                                whitelisted.findIndex(m => m === (this.meta.marketType || 'default')) >= 0
                            ) && (
                                !blacklisted.length ||
                                !(blacklisted.findIndex(m => m.replace('!', '') === (this.meta.marketType || 'default')) >= 0)
                            )
                        )
                    }
                }

                return true
            },
            overlayOpened () {
                this.adjustOpenOverlaysCounter({ value: true })
            },
            overlayClosed () {
                this.adjustOpenOverlaysCounter({ value: false })
            },
            changeLocation () {
                this.toggleCheckAvailabilityModal({
                    visible: true,
                    routeToBuyflow: false,
                    resetSelectedOffer: true,
                    currentCustomerCheck: false,
                })
            },
            getStarted () {
                // TODO redirect to page with speed quiz
            },
            showSearch () {
                // TODO no idea, no designs yet
            },
        },
    }
</script>
